import React from "react";

const WHITE_KEY_COUNT = 14;
const BLACK_KEY_AFTER = [0, 1, 3, 4, 5, 7, 8, 10, 11, 12];

export default function VstMiniKeyboard({ className = "" }) {
  return (
    <span className={`block overflow-hidden rounded-sm border border-black/70 bg-zinc-200 shadow-xl ${className}`} aria-hidden="true">
      <span className="absolute inset-0 flex">
        {Array.from({ length: WHITE_KEY_COUNT }, (_, index) => (
          <i key={index} className="h-full min-w-0 flex-1 border-r border-zinc-500/70 bg-gradient-to-b from-white to-zinc-300 last:border-r-0" />
        ))}
      </span>
      {BLACK_KEY_AFTER.map((whiteIndex) => (
        <i
          key={whiteIndex}
          className="absolute top-0 z-10 h-[61%] rounded-b-[2px] border border-black bg-gradient-to-b from-zinc-700 via-zinc-950 to-black shadow-md"
          style={{ left: `${((whiteIndex + 1) / WHITE_KEY_COUNT) * 100 - 2.15}%`, width: "4.3%" }}
        />
      ))}
    </span>
  );
}
